<template>
  <div class="MediaGridItemTestimonials">

    <h3 class="MediaGridItemTestimonials-title t-heading-sm"
      v-if="data.title">
      {{ data.title }}
    </h3>

    <blockquote class="MediaGridItemTestimonials-testimonial"
      v-for="item in data.items">

      <markdown class="MediaGridItemTestimonials-quote"
        v-if="item.quote"
        :content="item.quote" />

      <cite v-if="item.citation">
        <p class="MediaGridItemTestimonials-citation">
          {{ item.citation }}
        </p>
      </cite>

    </blockquote>

  </div>
</template>

<script>
export default {
  name: 'MediaGridItemTestimonials',

  props: {
    data: {
      type: Object,
      required: true
    }
  }
}
</script>

<style>
@import 'properties';

.MediaGridItemTestimonials {
  display: flex;
  flex-direction: column;
  height: 100%;
}

.MediaGridItemTestimonials-title {
  /* Leading compensation */
  margin-top: -5px; /* 0px */
  margin-bottom: -6px; /* 0px */
}

.MediaGridItemTestimonials-testimonial {
  padding: 0 24px;
  color: var(--c-grey-lt);
  -webkit-font-smoothing: antialiased;

  @media (min-width: 800px) {
    padding: 0 48px;
  }
}

.MediaGridItemTestimonials-testimonial + .MediaGridItemTestimonials-testimonial {
  margin-top: 48px;
}

.MediaGridItemTestimonials-quote {
  /* Leading compensation */
  margin-top: 12px;
  margin-bottom: -8px;

  font-size: 24px;
  line-height: 36px;
}

.MediaGridItemTestimonials-quote .Markdown-content > * {
  position: relative;
}

.MediaGridItemTestimonials-quote .Markdown-content > *::before {
  position: absolute;
  right: 100%;
  content: "“";
}

.MediaGridItemTestimonials-quote .Markdown-content > *::after {
  content: "”";
}

.MediaGridItemTestimonials-citation {
  /* Leading compensation */
  margin-top: 21px;
  margin-bottom: 24px;

  font-size: 13px;
  font-style: normal;
}
</style>



// WEBPACK FOOTER //
// MediaGridItemTestimonials.vue?abf8cb54